<template>
    
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container d-flex flex-column">
                <header class="mdc-top-app-bar position-static">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="$router.go(-1)">close</a>
                        </section>
                        
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title">{{title}}</div>                
                        </section>

                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                        </section>
                    </div>
                </header>

                <section class="flex-grow-1 scroll-y">
                    <!-- {{lessonData}} -->
                    <div class="t-headline5 pdt-18 pdb-14 pdl-16 pdr-16">
                        {{reviewSummaryData.average}}
                        <span class="t-body3 t-color-content1">
                            {{$t('864')}}
                            <!-- 평균 평점 -->
                        </span>
                    </div>
                    <div class="degree-view-star">
                        <ReviewListItem
                            v-for="(review, index) in reviewData" :key="index"
                            :review="review"
                        ></ReviewListItem>
                    </div>

                    <infinite-loading @infinite="fetchData"  :identifier="infiniteId" spinner="spiral">
                        <div slot="no-more" class="pda-default">No more data</div>
                        <div slot="no-results" class="pda-default"></div>
                    </infinite-loading>
                    
                </section>
                <!-- {{reviewData}} -->
                
                <!-- <div ref="loading" class="vld-parent" v-if="!isLastPage"></div> -->
            </div>
            
        </div>
        
    </div>
    
</template>

<script>
/**
 * 리뷰 목록 컴포넌트(review list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import InfiniteLoading from 'vue-infinite-loading'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import ReviewListItem from './ListItem.vue' 
import degreeApi from '@/api/degreeApi.js'

export default {
    components: {
        ReviewListItem, InfiniteLoading
    },
    data() {
        return {
            title: this.$t('863'),
            reviewData: [],
            totalPages: 1,
            currentPage: 1,
            reviewSummaryData: {},
            infiniteId: +new Date(),
            isNoData: false
        }
    },
    
    methods: {
        // call api data
        fetchData($state) {           
            
            let responseData = null
            let params = this.setParams()
            
            // call api review summary data
            degreeApi.guestLearnOnlineViewReviewSummary(params).then((response) => {
                this.reviewSummaryData = response.data.data
            }).catch((err) => {})

            
            if (this.totalPages >= this.currentPage) {

                // call api review list data
                degreeApi.guestLearnOnlineViewReview(params).then((response) => {
                    responseData = response.data.data
                    this.reviewData = this.reviewData.concat(responseData.content)
                    this.currentPage++
                    this.totalPages = responseData.totalPages
                    
                    if (responseData.content.length) {
                        $state.loaded()
                    }else {
                        $state.complete()
                    }
                }).catch((err) => {
                    $state.error()
                })
            }else {
                $state.complete()
            }

        },

        // set parameters
        setParams() {
            const params = {
                degreeId: this.$route.params.degreeId,
                page: this.currentPage
            }
            return params
        },

    }
}
</script>
